import { render, staticRenderFns } from "./cloudTagsWise.vue?vue&type=template&id=2fd20dd1&scoped=true&"
import script from "./cloudTagsWise.vue?vue&type=script&lang=js&"
export * from "./cloudTagsWise.vue?vue&type=script&lang=js&"
import style0 from "./cloudTagsWise.vue?vue&type=style&index=0&id=2fd20dd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd20dd1",
  null
  
)

export default component.exports